import * as React from 'react'
import { SVGComponentProps } from '../type'

const GalleryIcon = (props: SVGComponentProps) => (
  <svg
    width={props.width}
    height={props.height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0026 15.1666H6.0026C2.3826 15.1666 0.835938 13.6199 0.835938 9.99992V5.99992C0.835938 2.37992 2.3826 0.833252 6.0026 0.833252H10.0026C13.6226 0.833252 15.1693 2.37992 15.1693 5.99992V9.99992C15.1693 13.6199 13.6226 15.1666 10.0026 15.1666ZM6.0026 1.83325C2.92927 1.83325 1.83594 2.92659 1.83594 5.99992V9.99992C1.83594 13.0733 2.92927 14.1666 6.0026 14.1666H10.0026C13.0759 14.1666 14.1693 13.0733 14.1693 9.99992V5.99992C14.1693 2.92659 13.0759 1.83325 10.0026 1.83325H6.0026Z"
      fill={props.fill}
    />
    <path
      d="M5.9974 7.16667C4.98406 7.16667 4.16406 6.34667 4.16406 5.33333C4.16406 4.32 4.98406 3.5 5.9974 3.5C7.01073 3.5 7.83073 4.32 7.83073 5.33333C7.83073 6.34667 7.01073 7.16667 5.9974 7.16667ZM5.9974 4.5C5.5374 4.5 5.16406 4.87333 5.16406 5.33333C5.16406 5.79333 5.5374 6.16667 5.9974 6.16667C6.4574 6.16667 6.83073 5.79333 6.83073 5.33333C6.83073 4.87333 6.4574 4.5 5.9974 4.5Z"
      fill={props.fill}
    />
    <path
      d="M1.7792 13.1333C1.6192 13.1333 1.4592 13.0533 1.36586 12.9133C1.21253 12.6866 1.27253 12.3733 1.50586 12.22L4.79253 10.0133C5.51253 9.52662 6.50586 9.58662 7.1592 10.14L7.3792 10.3333C7.71253 10.62 8.2792 10.62 8.60586 10.3333L11.3792 7.95329C12.0859 7.34662 13.1992 7.34662 13.9125 7.95329L14.9992 8.88662C15.2059 9.06662 15.2325 9.37996 15.0525 9.59329C14.8725 9.79996 14.5592 9.82662 14.3459 9.64662L13.2592 8.71329C12.9259 8.42662 12.3592 8.42662 12.0259 8.71329L9.25253 11.0933C8.54586 11.7 7.43253 11.7 6.7192 11.0933L6.4992 10.9C6.19253 10.64 5.68586 10.6133 5.34586 10.8466L2.0592 13.0533C1.97253 13.1066 1.87253 13.1333 1.7792 13.1333Z"
      fill={props.fill}
    />
  </svg>
)

GalleryIcon.defaultProps = {
  width: 16,
  height: 16,
  fill: '#64748B'
}

export { GalleryIcon }
